<tour-step-template></tour-step-template>
<div class="app-container">
  <mat-sidenav-container
    class="container app-menu-sidenav-content"
    [hasBackdrop]="false"
    [ngClass]="{'not-expanded': !isExpanded, 'expanded': isExpanded}">
    <mat-sidenav
      *ngIf="auth.user | async as user"
      opened="{{ isExpanded }}"
      #drawer_mnu
      fixedInViewport="true"
      class="sidenav-menu"
      mode="push" position="start"
    >
      <side-nav
        #sidenav
        (toggleMenu)="toggleMenu()"
        [isExpanded]="isExpanded"
      ></side-nav>
    </mat-sidenav>
    <mat-sidenav #drawer class="sidenav" mode="side" position="end">
      <!-- <div *ngFor="let notif of appSvc.invitations"> -->
        <!-- Invitation: {{notif.name}} -->
        <!-- <button mat-icon-button (click)="acceptInvitation(notif)"><mat-icon>done</mat-icon></button> -->
        <!-- <button mat-icon-button (click)="cancelInvitation(notif)"><mat-icon>close</mat-icon></button> -->
      <!-- </div> -->
    </mat-sidenav>
    <div class="sidenav-content">
      <div class="flex-row flex">
        <div *ngIf="auth.user | async as user" class="app-header flex-row flex">
          <button class="show-small-sidenav" mat-icon-button *ngIf="!sidenav || !sidenav.isExpanded" (click)="sidenav.toggleMenu.emit(null)">
            <mat-icon>
              {{ sidenav && sidenav.isExpanded ? "keyboard_backspace" : "dehaze" }}
            </mat-icon>
          </button>
          <a routerLink="/">
            <img *ngIf="theme == 'light'" class="logo" height="30" src="/assets/images/logo-small.png" />
            <img *ngIf="theme == 'dark'" class="logo" height="30" src="/assets/images/logo-small-dark.png" />
          </a>
          <!-- <h1 class="flex">Welcome {{ user.displayName }}!</h1> -->
          <!-- <app-client-header *ngIf="auth.user | async as user" class="flex"></app-client-header> -->
          <app-client-header *ngIf="user && deviceType == 'desktop'" class="flex"></app-client-header>
          <div *ngIf="deviceType == 'handset'" class="flex"></div>
          <!-- <button mat-raised-button color="primary" (click)="openDialog()">Seleccionar cliente</button> -->
          <!-- <div *ngIf="appSvc.showDateRange && user && deviceType !== 'handset'" class="flex-row flex-column-gap-8 range"> -->
          @if (appSvc.showDateRange && appSvc.deviceType == 'desktop' && user) {
            <div class="flex-row flex-column-gap-8 range">
              <form [formGroup]="dateRangeForm">
                <mat-form-field
                  tourAnchor="date-ranges"
                  [appearance]="appSvc.formsAppearance"
                  class="range-select"
                  appearance-noload="outline"
                >
                  <mat-label>Rango de fechas</mat-label>
                  <mat-select formControlName="selectedDays">
                    <mat-option *ngFor="let days of datesOptions; let i = index" [value]="days.value">{{days.label}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </form>
              <mat-form-field [appearance]="appSvc.formsAppearance" *ngIf="this.selectedDays == 0" appearance-noload="outline" class="range-dates">
                <!-- <mat-label>Select Date Range</mat-label> -->

                <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRangeForm">
                  <input matStartDate placeholder="Start Date" formControlName="start">
                  <input matEndDate placeholder="End Date" formControlName="end">
                </mat-date-range-input>

                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </div>
          }
          <div class="header-actions flex-row flex-column-gap-8">
            <!-- <button tourAnchor="start-button" *ngIf="appSvc.user.superuser" mat-icon-button (click)="startTour()">
              <mat-icon class="main-help">help</mat-icon>
            </button> -->
            <!-- <button id="main-help" *ngIf="!appSvc.user.user_type || appSvc.user.user_type !== 'shopify'" mat-icon-button (click)="showHelp()"> -->
            <button tourAnchor="start-button" id="main-help" *ngIf="!appSvc.user.user_type || appSvc.user.user_type !== 'shopify'" mat-icon-button [mat-menu-trigger-for]="helpMenu">
              <mat-icon class="main-help">help</mat-icon>
            </button>
            <mat-menu #helpMenu="matMenu">
              <button mat-menu-item (click)="startTour()">Tour de nvio</button>
              <button mat-menu-item (click)="showHelp()">Chat de ayuda</button>
              @if (appSvc.user.superuser) {
                <button mat-menu-item (click)="toggleBlur()">{{blurred ? 'Desa' : 'A'}}ctivar modo incógnito</button>
              }
            </mat-menu>
            <button id="clients-selector" *ngIf="!appSvc.user.user_type || appSvc.user.user_type !== 'shopify'" mat-icon-button (click)="openDialog()">
              <mat-icon class="clients-selector">group_work</mat-icon>
            </button>
            <!-- <button -->
              <!-- mat-icon-button -->
              <!-- *ngIf="appSvc.invitations.length" -->
              <!-- (click)="drawer.toggle()" -->
            <!-- > -->
              <!-- <mat-icon -->
                <!-- [matBadge]="appSvc.invitations.length" -->
                <!-- [matBadgeHidden]="!appSvc.invitations.length" -->
                <!-- matBadgeColor="warn" -->
              <!-- > -->
                <!-- notifications -->
              <!-- </mat-icon> -->
            <!-- </button> -->
            <!-- <button mat-icon-button (click)="appSvc.logout()"><mat-icon>logout</mat-icon></button> -->
            <button
              *ngIf="appSvc.auth.email || appSvc.auth.id"
              mat-mini-fab
              color="primary"
              class="avatar-button"
              [matMenuTriggerFor]="beforeMenu"
            >
              <img
                [alt]="appSvc.auth.displayName"
                [src]="appSvc.auth.photoURL || 'assets/icons/user.png'"
                class="avatar"
                [ngClass]="{'small': false}" />
            </button>
            <mat-menu #beforeMenu="matMenu" xPosition="before">
              <div class="profile-card">
                <img
                  [alt]="appSvc.auth.displayName"
                  [src]="appSvc.auth.photoURL || 'assets/icons/user.png'"
                  class="big-avatar" />
                <h4>{{ appSvc.auth.displayName }}</h4>
                <p>{{ appSvc.auth.email }}</p>
                <mat-divider></mat-divider>
                <div class="flex-column flex-row-gap-16">
                  <mat-slide-toggle [checked]="isDark" (toggleChange)="toggleDarkTheme()">{{appSvc.deviceType === 'handset' ? 'Oscuro' : 'Modo oscuro'}}</mat-slide-toggle>
                  <button mat-stroked-button (click)="userSettings()">
                    Ajustes
                  </button>
                  <button mat-stroked-button (click)="appSvc.logout()">
                    Cerrar sesión
                  </button>
                </div>
                <!-- <mat-divider></mat-divider>
                <p class="profile-footer">
                  Made with ? by <a href="https://twitter.com/SiddAjmera">@SiddAjmera</a>
                </p> -->
              </div>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="header-handset">
      <app-client-header *ngIf="user && deviceType == 'handset'" class="flex"></app-client-header>
      <div *ngIf="appSvc.showDateRange && appSvc.deviceType == 'handset' && user" class="dates-handset flex-row full-width range">
        <form [formGroup]="dateRangeForm" class="flex-row full-width flex-column-gap-8">
          <mat-form-field tourAnchor="date-ranges" [appearance]="appSvc.formsAppearance" class="range-select flex" appearance-noload="outline">
            <mat-label>Rango de fechas</mat-label>
            <mat-select formControlName="selectedDays">
              <mat-option *ngFor="let days of datesOptions; let i = index" [value]="days.value">{{days.label}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field [appearance]="appSvc.formsAppearance" *ngIf="this.selectedDays == 0" appearance-noload="outline" class="range-dates flex">
            <!-- <mat-label>Select Date Range</mat-label> -->

            <mat-date-range-input [rangePicker]="picker" [formGroup]="dateRangeForm">
              <input matStartDate placeholder="Start Date" formControlName="start">
              <input matEndDate placeholder="End Date" formControlName="end">
            </mat-date-range-input>

            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </form>
      </div>
    </div>
    <div class="errors"
      *ngIf="(appSvc.auth.email && !appSvc.loadingData.firstLoad) && (!appSvc.selectedClient.domain_validated ||
              !appSvc.selectedClient.account ||
              (appSvc.selectedClient.account && appSvc.selectedClient.account.expired))"
    >
      <div
        *ngIf="!appSvc.selectedClient.domain_validated"
        class="error cursor-pointer"
        [routerLink]="'/clients/' + appSvc.selectedClient.id"
        [queryParams]="{tab: 'domain'}"
      >
        El dominio de envío de correos electrónicos no está validado, por favor configure sus registros DNS para poder realizar envíos.
      </div>
      <div
        *ngIf="!appSvc.selectedClient.account"
        class="error cursor-pointer"
        [routerLink]="'/clients/' + appSvc.selectedClient.id"
        [queryParams]="{tab: 'billing'}"
      >
        No tiene ninguna cuenta activa, debe seleccionar un plan para poder realizar envíos.
      </div>
      <div
        *ngIf="appSvc.selectedClient.account && appSvc.selectedClient.account.expired"
        class="error cursor-pointer"
        [routerLink]="'/clients/' + appSvc.selectedClient.id"
        [queryParams]="{tab: 'billing'}"
      >
        Su cuenta está inactiva o pendiente de pago, debe reactivarla para poder realizar envíos.
      </div>
    </div>
    <!-- <tawk></tawk> -->
    <router-outlet></router-outlet>
  </mat-sidenav-container>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true"><p style="color: white" >{{appSvc.spinnerMsg}}</p></ngx-spinner>
@if (appSvc.logged && appSvc.selectedClient.id && appSvc.loadingData.loading && appSvc.loadingData.firstLoad) {
  <div id="loading_data">
    <div class="loading_content">
      <img *ngIf="theme == 'light'" class="logo" height="40" src="/assets/images/logo-small.png" />
      <img *ngIf="theme == 'dark'" class="logo" height="40" src="/assets/images/logo-small-dark.png" />
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <ul>
        @if (appSvc.loadingData.campaigns) {
          <li>Cargando campañas...</li>
        } @else {
          <li class="success">Campañas cargadas</li>
        }
        @if (appSvc.loadingData.lists) {
          <li>Cargando listas...</li>
        } @else {
          <li class="success">Listas cargadas</li>
        }
        @if (appSvc.loadingData.flows) {
          <li>Cargando flujos...</li>
        } @else {
          <li class="success">Flujos cargados</li>
        }
        @if (appSvc.loadingData.profiles) {
          <li>Cargando perfiles...</li>
        } @else {
          <li class="success">Perfiles cargados</li>
        }
        @if (appSvc.loadingData.templates) {
          <li>Cargando plantillas...</li>
        } @else {
          <li class="success">Plantillas cargadas</li>
        }
        @if (appSvc.loadingData.popups) {
          <li>Cargando popups...</li>
        } @else {
          <li class="success">Popups cargados</li>
        }
      </ul>
    </div>
  </div>
}
